import { Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import ScrollToTop from "./components/ScrollToTop";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import FloatingCTA from "./components/FloatingCTA";

// Pages
import HomePage from "./pages/HomePage";
import ServicesIndexPage from "./pages/ServicesIndexPage";
import ServiceDetailPage from "./pages/ServiceDetailPage";
import GalleryPage from "./pages/GalleryPage";
import CSRPage from "./pages/CSRPage";
import ContactPage from "./pages/ContactPage";
import NotFoundPage from "./pages/NotFoundPage";
import ForbiddenPage from "./pages/ForbiddenPage";

export default function App() {
  return (
    <HelmetProvider>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col bg-stone-50 text-stone-800 font-sans selection:bg-red-100 selection:text-[#ce0611]">
        <Navbar />
        <main className="flex-1">
          <Routes>
            {/* Home */}
            <Route path="/" element={<HomePage />} />

            {/* Services */}
            <Route path="/vi-tilbyder" element={<ServicesIndexPage />} />
            <Route path="/nyt-tag-ribe" element={<ServiceDetailPage serviceType="tag" />} />
            <Route path="/nyt-tag" element={<ServiceDetailPage serviceType="tag" />} />
            <Route path="/nye-vinduer-og-doere-ribe" element={<ServiceDetailPage serviceType="vinduer-doere" />} />
            <Route path="/vinduer-doere" element={<ServiceDetailPage serviceType="vinduer-doere" />} />
            <Route path="/renovering-af-hus" element={<ServiceDetailPage serviceType="renovering" />} />
            <Route path="/tilbygning-vinterhave" element={<ServiceDetailPage serviceType="tilbygning-vinterhave" />} />
            <Route path="/snedkerarbejde" element={<ServiceDetailPage serviceType="snedkerarbejde" />} />

            {/* Gallery & Showcase */}
            <Route path="/galleri" element={<GalleryPage />} />

            {/* CSR & Sponsorships */}
            <Route path="/csr" element={<CSRPage />} />
            <Route path="/vi-stoetter" element={<CSRPage />} />

            {/* Contact */}
            <Route path="/kontakt" element={<ContactPage />} />

            {/* Error Pages */}
            <Route path="/403" element={<ForbiddenPage />} />
            <Route path="/404" element={<NotFoundPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        <Footer />
        <FloatingCTA />
      </div>
    </HelmetProvider>
  );
}
